// Cache IDs
const USER_POINTS_CACHE_ID = 'user-points';
const USER_PROMOTIONS_CACHE_ID = 'user-promotions';
const USER_REWARDS_CACHE_ID = 'user-rewards';

// Accessibility
const DEFAULT_ZOOM_FACTOR = 100;
const DEFAULT_TEXT_LEVEL = 100;
const INCREASED_TEXT_LEVEL = 150;
const TARGET_ZOOMED_WIDTH = 720;

export {
  USER_POINTS_CACHE_ID,
  USER_PROMOTIONS_CACHE_ID,
  USER_REWARDS_CACHE_ID,
  DEFAULT_ZOOM_FACTOR,
  DEFAULT_TEXT_LEVEL,
  INCREASED_TEXT_LEVEL,
  TARGET_ZOOMED_WIDTH,
};
